import { render, staticRenderFns } from "./DiagnosticoSociambientalEmLoteHistorico.vue?vue&type=template&id=795c2e6e&lang=pug"
import script from "./DiagnosticoSociambientalEmLoteHistorico.vue?vue&type=script&lang=js"
export * from "./DiagnosticoSociambientalEmLoteHistorico.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticoSociambientalEmLoteHistorico.vue?vue&type=style&index=0&id=795c2e6e&prod&lang=scss&slot-scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports